import styled, { StyledProps } from 'styled-components/macro';
import { Button } from '../../components/Button/ButtonStyles';

export type DropdownButtonStylesProps = StyledProps<{
  variant: 'primary' | 'secondary' | 'tertiary';
  disabled: boolean;
  split?: boolean;
}>;

export const DropdownButton = styled.div<DropdownButtonStylesProps>`
  ${Button} {
    &:after {
      order: 2;
    }

    ${(props) =>
      props.split && props.variant === 'primary'
        ? `
        &:before {
          content: "";
          display: inline-block;
          margin-left: 8px;
          height: 15px;
          order: 1;
          border-left: 1px solid ${
            props.variant === 'primary' ? '#005F99' : props.theme.colors.gray
          };
        }`
        : ''}
  }
`;

export const Menu = styled.div`
  min-width: 100%;
  padding: 5px 0;
  box-shadow: 0px 1px 18px rgba(129, 129, 129, 0.12),
    0px 3px 5px rgba(129, 129, 129, 0.2), 0px 6px 10px rgba(129, 129, 129, 0.14);
  border-radius: 3px;
  border: 1px solid #e6e6e6;
  background-color: ${(props) => props.theme.colors.white};
  overflow: hidden;

  & > .dropdown-divider {
    margin: 0 10px;
    border-color: ${(props) => props.theme.colors.grayLight};
  }

  & > .dropdown-item {
    font-size: 14px;
    color: #1d1e25;
    padding: 0 10px;
    height: 25px;
    background-color: ${(props) => props.theme.colors.white};
    transition: 0.2s;
    margin: 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 25px;

    & > svg {
      margin: 0px 5px 2px 0;
    }

    &:active,
    &:hover {
      background-color: #d7e8fe;
    }
  }
`;
